/* eslint-disable @typescript-eslint/no-explicit-any */
import { NativeSelectFieldProps, NativeSelectRootProps, NativeSelect as Select } from '@chakra-ui/react/native-select'
import * as React from 'react'

export const NativeSelectRoot = React.forwardRef(function NativeSelect(
  props: NativeSelectRootProps & { icon?: any },
  ref: React.Ref<HTMLDivElement>,
) {
  const { icon, children, ...rest } = props
  return (
    <Select.Root ref={ref} {...rest}>
      {children}
      <Select.Indicator>{icon}</Select.Indicator>
    </Select.Root>
  )
})

export const NativeSelectField = React.forwardRef(function NativeSelectField(
  props: NativeSelectFieldProps,
  ref: React.Ref<HTMLSelectElement>,
) {
  const { children, ...rest } = props

  return (
    <Select.Field ref={ref} {...rest}>
      {children}
    </Select.Field>
  )
})
